import CustomerSearch from 'components/pages/CustomerSearch';
import CustomerDetails from 'components/pages/CustomerDetails';
import Transactions from 'components/pages/Transactions';
import {
  AddSuspension,
  EditSuspension,
  RedirectToSuspensionsPage,
} from 'components/pages/Suspensions';
import Cancellation from 'components/pages/Cancellation';
import CustomerEmbedFrame from 'components/pages/CustomerEmbedFrame';
import PaymentsEmbedFrame from 'components/pages/CustomerEmbedFrame/PaymentsEmbedFrame';
import CustomerDetailsRedirect from 'components/pages/CustomerDetailsRedirect';
import withScrollableTopTabs from 'hoc/withScrollableTopTabs';
import customerPageTopTabs from 'constants/customerPageTopTabs';

// Must be in decreasing order of the path length.
const routes = [
  {
    path: '/Customers/:adfitNo/Payments',
    component: [
      {
        path: '/Customers/:adfitNo/Payments/:subTab',
        ignoreForBreadCrumb: true,
        component: withScrollableTopTabs(customerPageTopTabs, 1, ['adfitNo'])(
          PaymentsEmbedFrame
        ),
      },
      {
        path: '/Customers/:adfitNo/Payments',
        component: withScrollableTopTabs(customerPageTopTabs, 1, ['adfitNo'])(
          PaymentsEmbedFrame
        ),
      },
    ],
  },
  {
    path: '/Customers/:adfitNo/Suspensions',
    component: [
      {
        path: '/Customers/:adfitNo/Suspensions/Add',
        component: AddSuspension,
        breadCrumbName: 'Add',
      },
      {
        path: '/Customers/:adfitNo/Suspensions/Edit',
        breadCrumbName: 'Edit',
        component: [
          {
            path: '/Customers/:adfitNo/Suspensions/Edit/:scheduleSuspenseId',
            component: EditSuspension,
            ignoreForBreadCrumb: true,
          },
          {
            path: '/Customers/:adfitNo/Suspensions/Edit',
            component: RedirectToSuspensionsPage,
          },
        ],
      },
      {
        path: '/Customers/:adfitNo/Suspensions',
        component: RedirectToSuspensionsPage,
      },
    ],
  },
  {
    path: '/Customers/:adfitNo/Transactions',
    component: Transactions,
  },
  {
    path: '/Customers/:adfitNo/PaymentMethod',
    component: withScrollableTopTabs(customerPageTopTabs, 3, ['adfitNo'])(
      CustomerEmbedFrame
    ),
  },
  {
    path: '/Customers/:adfitNo/Activities',
    component: withScrollableTopTabs(customerPageTopTabs, 4, ['adfitNo'])(
      CustomerEmbedFrame
    ),
  },
  {
    path: '/Customers/:adfitNo/Variations',
    component: withScrollableTopTabs(customerPageTopTabs, 5, ['adfitNo'])(
      CustomerEmbedFrame
    ),
  },
  {
    path: '/Customers/:adfitNo/Contract',
    component: withScrollableTopTabs(customerPageTopTabs, 6, ['adfitNo'])(
      CustomerEmbedFrame
    ),
  },
  {
    path: '/Customers/:adfitNo/Overview',
    component: [
      {
        path: '/Customers/:adfitNo/Overview/AccountCancellation',
        component: Cancellation,
        breadCrumbName: 'Account Cancellation',
      },
      {
        path: '/Customers/:adfitNo/Overview',
        component: CustomerDetails,
        breadCrumbName: 'Overview',
      },
    ],
  },
  {
    path: '/Customers/:adfitNo',
    component: CustomerDetailsRedirect,
    ignoreForBreadCrumb: true,
  },
  {
    path: '/Customers',
    component: CustomerSearch,
  },
];

export default routes;
